import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  withFormik,
} from 'formik';
import { Form as SemanticForm } from 'semantic-ui-react';

import Success from './components/success';
import ForgotPasswordForm from './components/forgot-password';
import { forgotPassword } from './request';

import {
  Container,
  Logo,
  Segment,
} from './styles';
import schema from './schema';

const ForgotPassword = (props) => {
  const { validateForm, values } = props;

  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async () => {
    const validationErrors = await validateForm();
    const isValid = Object.keys(validationErrors).length === 0;
    if (isValid) {
      try {
        const { email } = values;

        setLoading(true);
        await forgotPassword(email);
        setSuccess(true);
      } catch (err) {
        const error = (err && err.code && err.message)
          ? err.message
          : 'Error while sending email, please try again';

        setSubmitError(error);
        setLoading(false);
      }
    }
  };

  return (
    <Container>
      <Logo src="/images/playbook-logo.png" alt="Playbook" />

      <Segment>
        {!success && (
          <Form>
            <SemanticForm as="div">
              <ForgotPasswordForm
                loading={loading}
                submitError={submitError}
                onSubmit={handleSubmit}
              />
            </SemanticForm>
          </Form>
        )}
        {success && <Success />}
      </Segment>

    </Container>
  );
};

ForgotPassword.propTypes = {
  validateForm: PropTypes.func.isRequired,
  values: PropTypes.shape({
    email: PropTypes.string,
  }).isRequired,
};

export default withFormik({
  validationSchema: schema,
  mapPropsToValues: () => ({
    email: '',
  }),
})(ForgotPassword);
